var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLogoFruta = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 24,
  viewBox: "0 0 23 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.9091 6.5459C13.7962 6.5459 11.2727 9.15082 11.2727 12.3641C11.2727 9.15082 8.74921 6.5459 5.63636 6.5459C2.52351 6.5459 0 9.15082 0 12.3641C0 18.7907 5.04691 24.0004 11.2727 24.0004C17.4985 24.0004 22.5455 18.7907 22.5455 12.3641C22.5455 9.15082 20.0219 6.5459 16.9091 6.5459Z",
  fill: "#F26522"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.7274 2.80501H12.0728C11.4301 2.80501 10.9092 3.34001 10.9092 4V8C12.2966 6.28638 14.3878 5.19499 16.7274 5.19499H21.3819C22.0246 5.19499 22.5455 4.65988 22.5455 4V0C21.1581 1.71362 19.067 2.80501 16.7274 2.80501Z",
  fill: "#F26522"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoFruta, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo_fruta.582f6de2.svg";
export { ForwardRef as ReactComponent };